import { Component, effect, input, signal, TemplateRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NzSelectModeType,
  NzSelectModule,
  NzSelectSizeType,
} from 'ng-zorro-antd/select';
import { ControlBase } from '../base/base.component';

@Component({
  imports: [ReactiveFormsModule, NzSelectModule],
  selector: 'control-select-group',
  template: `
    @if (control()) {
      <nz-select
        [class]="baseClasses"
        [formControl]="control()"
        [nzShowArrow]="true"
        [nzSize]="size()"
        [nzPlaceHolder]="placeholder() || label()"
        [nzMode]="mode()"
        [nzMaxMultipleCount]="maxMultipleCount()"
        [nzShowArrow]="true"
        [nzBorderless]="borderless()"
        [nzMaxTagCount]="1"
        [nzShowSearch]="true"
        [nzCustomTemplate]="multipleTemplate()"
        [nzMaxTagPlaceholder]="tagPlaceHolder() || defaultTagPlaceHolder"
        [nzDropdownMatchSelectWidth]="false"
      >
        @for (optionGroup of options(); track optionGroup.value) {
          <nz-option-group [nzLabel]="optionGroup.label">
            @for (option of optionGroup.options; track option.value) {
              <nz-option
                [nzValue]="option.value"
                [nzLabel]="option.label"
                [nzDisabled]="option.disabled || false"
              ></nz-option>
            }
          </nz-option-group>

        }
      </nz-select>
      <ng-template #defaultTagPlaceHolder let-selectedList>
        <span class="mr-1"> +{{ selectedList.length }} </span>
      </ng-template>
    }
  `,
})
export class ControlSelectGroupComponent extends ControlBase {
  options = input<any>();
  mode = input<NzSelectModeType>('default');
  maxMultipleCount = input<number>(Infinity);
  size = input<NzSelectSizeType>('default');
  multipleTemplate = input<TemplateRef<any> | null>(null);
  tagPlaceHolder = input<TemplateRef<any> | null>(null);
  borderless = input<boolean>(false);
}
